module.exports = __webpack_public_path__ + "static/img/t1-3.92de7f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/zh/t1-3.png
// module id = Iaa/
// module chunks = 1